export default interface Input {
    type: InputType
    name?: string
    label?: string
    mask?: string
    mode?: ColorMode
    path?: string
    disabled?: boolean
    required?: boolean
    validate?: string
    visible?: boolean | Function
    //  These are only for SELECT type
    itemText?: string
    itemValue?: string
    options?: any[]
    selected?: any
    //  Only for SLIDER type
    max?: number
    min?: number
    thumbLabel?: boolean
    //  Everything below is purely for styles
    'background-color'?: string
    color?: string
    cols?: number | string
    colClass?: string
    colStyle?: string | object
    dark?: boolean
    dense?: boolean
    filled?: boolean
    height?: number | string
    order?: number
    outlined?: boolean
    rounded?: boolean
    rows?: number | string
    shaped?: boolean
    class?: string
    labelHTML?: string
    labelStyle?: string | object
}

export enum ColorMode {
    hexa = 'hexa'
}

export enum InputType {
    CHECKBOX = 'CHECKBOX',
    COLORBTN = 'COLORBTN',
    DATE = 'DATE',
    DATETIME = 'DATETIME',
    LABEL = 'LABEL',
    MESSAGE_TEXT_FORM = 'MESSAGE_TEXT_FORM',
    PHONE = 'PHONE',
    TEXT = 'TEXT',
    TEXTAREA = 'TEXTAREA',
    SELECT = 'SELECT',
    SLIDER = 'SLIDER'
}